import type { FormType } from "../types";
export class Constants {
  private static dialog = document.createElement("dialog");
  public static popup = (() => {
    const toast = this.dialog ?? document.createElement("dialog");
    toast.className = `toast`;
    toast.popover = "manual";
    toast.style.position = "fixed";
    toast.style.maxWidth = 'calc(90vw * .154)';
    toast.style.maxHeight = 'calc(90vh * 0.155)';
    toast.style.fontSize = '1.015rem';
    toast.style.top = "5px";
    toast.style.right = "15px";
    toast.style.zIndex = "1000";
    toast.style.padding = "1rem";
    toast.style.borderRadius = "12px";
    toast.style.color = "auto";
    toast.style.boxShadow = "0 2px 10px rgba(0, 0, 0, 0.2)";
    toast.style.transition = "opacity 0.3s ease-in-out";
    toast.style.opacity = "0.9";
    toast.addEventListener("click", () => {
      toast.style.opacity = "0";
      setTimeout(() => {
        toast.remove();
      }, 500);
    });

    return toast;
  })();
  static readonly DEFAULT_LANGUAGE = "en";
  static readonly DEFAULT_COUNTRY = "us";
  static readonly DEFAULT_CURRENCY = "USD";
  static readonly DEFAULT_LOCALE = "en-US";
  static readonly DEFAULT_TIMEZONE = "America/Mexico_City";
  static readonly DEFAULT_DATE_FORMAT = "MM/DD/YYYY";
  static readonly DEFAULT_TIME_FORMAT = "hh:mm A";
  static readonly DEFAULT_DATETIME_FORMAT = "MM/DD/YYYY hh:mm A";
  static readonly DEFAULT_NUMBER_FORMAT = "#,##0.00";
  static readonly FormTypes: { [key: string]: keyof typeof FormType; } = {
    "Car": "Car",
    "Health": "Health",
    "Home": "Home",
    "Life": "Life",
    "Enterprises": "Enterprises",
    "Undefined": "Undefined"
  };
  public static showToast(message: string, type: "success" | "error" | "info" | "warning" = "info") {
    const toast = Constants.popup;
    toast.textContent = message;
    toast.style.backgroundColor = type === "success"
      ? "#4CAF50" : type === "error"
        ? "#F44336" : type === "info"
          ? "#2196F3" : type === "warning"
            ? "#FF9800" : "#9E9E9E";
    document.body.appendChild(toast);
    toast.style.transition = "0.67s ease-in-out opacity";
    toast.style.opacity = "1";
    toast.showPopover();
    setTimeout(() => {
      toast.style.opacity = "0";
      toast.close();
      toast.remove();
    }, 5000);
  }
}
